export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["buy"] = "BUY";
    OrderDirection["sell"] = "SELL";
})(OrderDirection || (OrderDirection = {}));
;
